<template lang="html">

  <section class="ficha -estudiante">

    <template v-if="!!data">

     <h2 class="ficha-title" :style="styles.colorBasic">{{$t('estudiante')}}</h2>

     <article class="group">

      <h3 class="group-title" :style="styles.colorBasic">{{$t('datos_personales')}}</h3>

      <div class="contenedor-data" v-if="!!data.Personales.nombre">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('nombre')}}</h4>
        <p>{{data.Personales.nombre}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.apellidos">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('apellidos')}}</h4>
        <p>{{data.Personales.apellidos}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.email">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('estudiante')}}</h4>
        <p><a :href="'mailto:'+data.Personales.email">{{data.Personales.email.replace(';', ' \n ')}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.movil">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('movil')}}</h4>
        <p><a :href="'tel:'+data.Personales.movil">{{data.Personales.movil}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.telefono">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('fijo')}}</h4>
        <p><a :href="'tel:'+data.Personales.telefono">{{data.Personales.telefono}}</a></p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.fecha_nacimiento">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_nacimiento')}}</h4>
        <p>{{data.Personales.fecha_nacimiento}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.nacionalidad">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('pais_nacionalidad')}}</h4>
        <p>{{data.Personales.nacionalidad}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.direccion">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('direccion')}}</h4>
        <p>{{data.Personales.direccion}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.ciudad">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('poblacion')}}</h4>
        <p>{{data.Personales.ciudad}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.provincia">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('provincia')}}</h4>
        <p>{{data.Personales.provincia}}</p>
      </div>

      <div class="contenedor-data" v-if="!!data.Personales.CP">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('cp')}}</h4>
        <p>{{data.Personales.CP}}</p>
      </div>

      <div class="contenedor-data" v-if="!!!brand.hideDiscapacidad">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('discapacidad')}}</h4>
        <p>{{(data.Personales.discapacidad) ? $t('si') : $t('no')}}</p>
      </div>

    </article>

    <article class="group" v-if="!!data.documentos && !!!brand.onlyShowCVinDocs">

     <h3 class="group-title" :style="styles.colorBasic">{{$t('documentos')}}</h3>

     <template v-for="doc in data.documentos">
       <div class="contenedor-data">
        <h4 class="data-title" :style="styles.colorBasic">{{(!!doc.nombre) ? doc.nombre : documentos[doc.tipo]}}</h4>
        <p class="descargar"><a :href="doc.enlace" target="_blank">{{$t('descargar')}}</a></p>
      </div>
    </template>


  </article>

  <article class="group" >

    <template v-if="!!data.academicos && !brand.hideDatosAcademicos">

    <h3 class="group-title" :style="styles.colorBasic">{{$t('datos_academicos')}}</h3>

    <div class="contenedor-data -full" v-for="academico in data.academicos"> 
      <div class="full-children -full">
         <h4 class="data-title" :style="styles.colorBasic">{{$t('titulacion')}}</h4>
         <p>{{academico.titulacion}}</p>
      </div>
      <div class="full-children">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('matriculado_practicas')}}</h4>
        <p>{{(academico.matriculadoOracticas) ? $t('si') : $t('no')}}</p>
      </div>
      <div class="full-children">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('practicas_pendientes')}}</h4>
        <p>{{(academico.PracticasPendientes) ? $t('si') : $t('no')}}</p>
      </div>
    </div>

  </template>


  <div class="contenedor-data">
    <arrow-link :text="'Ver CV del estudiante'" :external="true" :to="data.Personales.urlCV" :blank="true"></arrow-link>
  </div>

</article>

<template v-if="data.autorizacionPracticas.length > 0 && !brand.hideautorizacionPorCuatrimestre">

  <article class="group" v-for="(autorizacion, key) in data.autorizacionPracticas">

    <h3 class="group-title" :style="styles.colorBasic">{{$t('autorizacion_cuatrimestre')}}</h3>

    <div class="contenedor-data -full">
      
       <div class="full-children -full" v-if="key == 0 && !!data.autorizacionPorCuatrimestre">
         <p>{{data.autorizacionPorCuatrimestre}}</p>
      </div>

      <div class="full-children" v-if="!!autorizacion.anio">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('anyo')}}</h4>
        <p>{{autorizacion.anio}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.codigoEstudio">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('codigo_estudio')}}</h4>
        <p>{{autorizacion.codigoEstudio}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.atutorizacion">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('autorizacion')}}</h4>
        <p>{{(autorizacion.atutorizacion) ? $t('si') : $t('no')}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.periodo">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('periodo')}}</h4>
        <p>{{autorizacion.periodo}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.fechaResolucion">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('fecha_resolucion')}}</h4>
        <p>{{autorizacion.fechaResolucion}}</p>
      </div>
      <div class="full-children" v-if="!!autorizacion.horas">
        <h4 class="data-title" :style="styles.colorBasic">{{$t('horas')}}</h4>
        <p>{{autorizacion.horas}}</p>
      </div>
    </div>

  </article>

</template>

</template>


</section>

</template>

<script lang="js">


  import {mapGetters, mapActions} from 'vuex';

  import onlyArrow  from '@/components/parts/icons/only-arrow';
  import arrowlink  from '@/components/parts/icons/arrow-link';

  export default  {
    name: 'ficha-estudiante',
    props : ['data'],
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        brand : 'getBrand'
      })
    },
    components : {
      'only-arrow' : onlyArrow,
      'arrow-link' : arrowlink,
    }
  }
</script>

<style scoped lang="scss">
  .ficha-estudiante {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-estudiante.vue